/**
 * Line Type Enum
 *
 * Defines the interpolation types for line geometry.
 * Determines how points are connected when rendering lines on the map.
 *
 * Available types: Straight (sharp corners) → Curved (smooth, flowing)
 *
 * @enum {string}
 */
export enum LineType {
  /**
   * Straight line segments
   * Direct connection between points with sharp corners
   * No interpolation applied
   * Default line type
   */
  Straight = 'Straight',

  /**
   * Smooth curved lines
   * Subtle, flowing transitions through all points
   * Uses Catmull-Rom spline interpolation (C1 continuity)
   */
  Curved = 'Curved',
}
